module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/neuenburg-6ca57e2dbcaa52e5610d2ea6222baf53.png";